export default __webpack_public_path__ + "static/media/twitter.536733a8.svg";